module.exports = __webpack_public_path__ + "img/alach_no.7468f219.png";